module.exports = __webpack_public_path__ + "img/check-big.b5583440.svg";